// Utility to load Google Maps API dynamically
// This allows us to use environment variables for the API key

let isLoading = false;
let isLoaded = false;

export const loadGoogleMapsApi = () => {
  return new Promise((resolve, reject) => {
    // Already loaded
    if (isLoaded || (window.google && window.google.maps)) {
      isLoaded = true;
      resolve(window.google.maps);
      return;
    }

    // Already loading, wait for it
    if (isLoading) {
      const checkLoaded = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkLoaded);
          isLoaded = true;
          resolve(window.google.maps);
        }
      }, 100);
      return;
    }

    isLoading = true;

    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    
    if (!apiKey) {
      console.warn('Google Maps API key not found in environment variables');
      reject(new Error('Google Maps API key not configured'));
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      isLoading = false;
      isLoaded = true;
      console.log('Google Maps API loaded successfully');
      resolve(window.google.maps);
    };

    script.onerror = () => {
      isLoading = false;
      console.error('Failed to load Google Maps API');
      reject(new Error('Failed to load Google Maps API'));
    };

    document.head.appendChild(script);
  });
};

export default loadGoogleMapsApi;
